import React, { useState } from 'react';
import { useNavigate, Navigate } from 'react-router-dom';
import { useAuthStore } from '../stores/authStore';
import type { LoginForm } from '../types';
import LoadingScreen from '../components/LoadingScreen';

const Login: React.FC = () => {
  const navigate = useNavigate();
  const { login, isAuthenticated, isLoading } = useAuthStore();
  const [email, setEmail] = useState('');
  const [senha, setSenha] = useState('');
  const [error, setError] = useState<string | null>(null);

  if (isAuthenticated) {
    return <Navigate to="/dashboard" replace />;
  }
  if (isLoading) {
    return <LoadingScreen message="Entrando..." className="min-h-screen bg-white" />;
  }

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);

    if (!email.trim()) {
      setError('Email é obrigatório');
      return;
    }
    if (!senha) {
      setError('Senha é obrigatória');
      return;
    }

    const credentials: LoginForm = { email: email.trim(), senha };
    try {
      await login(credentials);
      navigate('/dashboard', { replace: true });
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Erro ao fazer login');
    }
  };

  return (
    <div className="min-h-screen flex bg-white items-center justify-center p-4">
      <div className="w-full max-w-md space-y-6">
        <div className="text-center mb-4">
          <h1 className="text-2xl font-bold text-gray-900 mb-2">
            Nexus Motorista
          </h1>
          <p className="text-gray-600 text-sm">
            Acesse sua conta para gerenciar suas fases
          </p>
        </div>

        <div className="bg-white rounded-lg shadow-lg p-6 border border-gray-300">
          <form onSubmit={handleSubmit} className="space-y-6">
            {error && (
              <div className="error-box" role="alert">
                {error}
              </div>
            )}

            <div>
              <label htmlFor="email" className="label">
                Email
              </label>
              <input
                id="email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="seu@email.com"
                autoComplete="email"
                disabled={isLoading}
              />
            </div>

            <div>
              <label htmlFor="senha" className="label">
                Senha
              </label>
              <input
                id="senha"
                type="password"
                value={senha}
                onChange={(e) => setSenha(e.target.value)}
                placeholder="••••••••"
                autoComplete="current-password"
                disabled={isLoading}
              />
            </div>

            <button
              type="submit"
              className="btn-primary"
              disabled={isLoading}
            >
              {isLoading ? 'Entrando...' : 'Entrar'}
            </button>
          </form>
        </div>

        <p className="text-center text-gray-500 text-sm">
          Sistema Nexus Funerária – App Motorista (Web)
        </p>
      </div>
    </div>
  );
};

export default Login;
